export const getDisplayApr = (incRewardsApr?: number, lpRewardsApr?: number) => {
  if (incRewardsApr && lpRewardsApr) {
    return (incRewardsApr + lpRewardsApr).toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  if (incRewardsApr) {
    return incRewardsApr.toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  return null
}
